<template>
	<div class="header">
		<div class="header_img">
			<img src="data:image/png;base64,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"/>
		</div>
		<div class="header_company">
			<span class="header_company_name">哈尔滨了然科技开发有限公司</span>
			<span class="header_company_name_en">Harbin Liaoran Technology Development Co.</span>
		</div>
		<ul class="header_menu">
			<li @click="jumpTo('/')">首页</li>
			<li @click="jumpTo('/?mount=product')">产品中心</li>
			<li @click="jumpTo('/?mount=about')">公司介绍</li>
			<li @click="jumpTo('/?mount=news')">新闻资讯</li>
			<li  @click="jumpTo('/?mount=download')">下载中心</li>
			<li @click="scrollToSection('footer')">联系我们</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "lrHeader",
	props: {
		footerLogo: {
			type:String,
			default:"data:image/png;base64,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"
		},
		companyName: {
			type:String,
			default:""
		},
		companyNameEn: {
			type:String,
			default:""
		},
		companyTel: {
			type: String,
			default: ""
		},
		companyPhone: {
			type: String,
			default: ""
		},
		companyEmail: {
			type: String,
			default: ""
		}
	},

	mounted() {

	},

	methods: {
		toPages(url) {
			this.$router.push(url);
		},
		jumpTo(url){
			console.log(url);
			this.$router.push(url);
		},
		scrollToSection(key) {
			this.$emit("toSection",key);
		}
	},
};
</script>
<style scoped>
.header {
	padding-left: 10rem;
	/*padding-right: 15rem;*/
	/* width: 100%; */
	align-items: center;
	justify-content: flex-start;
	display: flex;

	height: 6.25rem;
	background: #FFFFFF;
	border-radius: 4.8125rem 4.8125rem 4.8125rem 4.8125rem;
}

.header_img {
	/* margin-left: 6.625rem; */

	width: 3.125rem;
	height: 4.3125rem;
	margin: 1.0625rem 0 0 6.625rem;
}
.header_company {
	/* width: 29%; */
	height: 3.625rem;
	margin: 1.625rem 1.8rem 0 1.0625rem;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
}
.header_company_name {
	height: 1.6875rem;
	overflow-wrap: break-word;
	color: rgba(61, 61, 61, 1);
	font-size: 1.5rem;
	font-family: DingTalk JinBuTi-Regular;
	text-align: left;
	white-space: nowrap;
	line-height: 1.8125rem;
}
.header_company_name_en {
	height: 1.6875rem;
	overflow-wrap: break-word;
	color: rgba(61, 61, 61, 1);
	font-size: 0.875rem;
	font-family: DingTalk JinBuTi-Regular;
	text-align: left;
	white-space: nowrap;
	line-height: 1.0625rem;
	margin: 4px 0 0 1px;
}

.header_menu {
	/* margin-right: 7.5625rem; */
	list-style: none;
}
.header_menu > li {
	display: inline-block;
	height: 6.125rem;
	line-height: 6.125rem;
	/* border-bottom: 4px solid blue; */
	/* margin-left: 2.6rem; */
	padding: 0 1.1rem;
	font-size: 1rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	cursor: pointer;
}
</style>
